module.exports = __webpack_public_path__ + "img/map.363ec03d.png";